import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=a7fc1c8e"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports